<template>
<div class="content" id="ComponentIndex">
	<router-view />
</div>
</template>
<script>
export default {
    name: 'ComponentIndex',
    //组件创建
    created() {
    },
    data() {
        return{
        }
    },
    methods:{
    }
}
</script>
<style lang="less" scoped>
</style>